import { ChangeDetectorRef, Component, ViewChild, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { STColumn, STChange, STData, STComponent } from '@delon/abc/st';
import { _HttpClient } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-supplier-do-address-select',
  templateUrl: './supplier-do-address-select.component.html',
  styleUrls: ['supplier-do-address-select.component.less'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SupDOAddressSelectComponent),
      multi: true
    }
  ]
})
export class SupDOAddressSelectComponent implements ControlValueAccessor {
  @ViewChild('st') st!: STComponent;
  visible = false;
  @Input() borderless = false;
  @Input() currency: any;

  @Input() value: any;
  @Input() disabled = false;
  @Input() supplierId: string | null | undefined = undefined;

  @Output() readonly valueChanged = new EventEmitter();

  data: any = [];
  get readonly() {
    if (this.disabled || this.currency?.local) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  selected: any = null;

  columns: STColumn[] = [
    {
      title: ' ',
      type: 'radio',
      width: 50
    },
    {
      index: 'branchCode',
      title: '#',
      width: 150
    },
    {
      index: 'branchName',
      title: 'Branch Name',
      width: 200
    },
    {
      index: 'contactPerson',
      title: 'Contact',
      width: 150
    },
    {
      index: 'email',
      title: 'Email',
      width: 200
    },
    {
      index: 'phoneNo',
      title: 'Phone',
      width: 150
    },
    {
      index: 'faxNo',
      title: 'Fax',
      width: 150
    }
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    private msg: NzMessageService,
    private http: _HttpClient,
  ) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  showModal() {
    if (!this.supplierId) {
      this.msg.warning('Customer is required');
      return;
    }

    let url = `api/supplierdeliveryaddresses/lookup?$orderby=branchCode asc&$filter=SupplierId eq ${this.supplierId}`;
    this.http.get(url).subscribe({
      next: (res: any) => {
        this.data = res.value;

        if (this.value) {
          var index = this.data.findIndex((o: any) => o.branchCode === this.value);
  
          if (index !== -1) {
            setTimeout(() => {
              this.st.setRow(index, { checked: true });
            }, 100);
          }
        }
        this.visible = true;
      }
    });
  }

  submit() {
    this.valueChanged.emit(this.selected);
    this.visible = false;
  }

  change(res: STChange) {
    if (res.radio){
      this.selected = res.radio;
    }
  }

  clear() {
    this.selected = null;
    this.st.clearRadio();
  }
}
